import * as React from "react";
import { inject, observer } from "mobx-react";

import { WizardHotelPWAv2HotwireView } from "./views/WizardHotelPWAv2HotwireView";
import { WizardHotelPWAv2View } from "./views/WizardHotelPWAv2View";
import { WizardHotelPWAv2HTGView } from "./views/WizardHotelPWAv2HTGView";
import { WizardHotelPWAv2Views } from "./utils/WizardHotelPWAv2Views";
import { WizardHotelPWAv2Props, WizardHotelPWAv2FTNodeOptions } from "./typings";
import { normalizeOptionsData } from "src/stores/FlexTemplateStore";

const getComponentFromView = (view?: string) => {
  switch (view) {
    case WizardHotelPWAv2Views.HOTWIRE:
      return WizardHotelPWAv2HotwireView;
    case WizardHotelPWAv2Views.HTG:
      return WizardHotelPWAv2HTGView;
    default:
      return WizardHotelPWAv2View;
  }
};

@inject("analytics", "experiment", "page", "wizardState", "compositionStore", "flexModuleModelStore")
@observer
export class WizardHotelPWAv2 extends React.Component<WizardHotelPWAv2Props> {
  private options: WizardHotelPWAv2FTNodeOptions;
  constructor(props: WizardHotelPWAv2Props) {
    super(props);

    const hotelWizardState = this.props.wizardState.hotelWizardState;
    const hotelWizardConfig = hotelWizardState.config;
    const isDesktop = Boolean(
      !this.props.context.deviceInformation?.mobile && !this.props.context.deviceInformation?.tablet
    );
    const { flexTemplateNode, flexModuleModelStore } = this.props;
    const { id } = flexTemplateNode;

    const model = flexModuleModelStore.getModel(id);
    this.options = normalizeOptionsData(flexTemplateNode, model) as WizardHotelPWAv2FTNodeOptions;

    hotelWizardState.overrideConfig(() => {
      hotelWizardConfig.elementId = id;
      hotelWizardConfig.heading.fixedTitle = this.options.fixedLobTitle === false ? false : true;
      hotelWizardConfig.heading.title = this.options.lobTitle;
      hotelWizardConfig.lastSearch.useLastSearchForSingleLOB = this.options.useLastSearchForSingleLOB;
      hotelWizardConfig.includeFiltersHotelPWAWizard = this.options.includeFiltersHotelPWAWizard;
      hotelWizardConfig.analytics = this.props.analytics;
      hotelWizardConfig.enableMultiplePlaces = this.options.enableMultiplePlaces;
      hotelWizardConfig.heading.hideLobTitle = this.options.hideLobTitle;
      hotelWizardState.config.heading.lobSubtitleBreakPoint = this.options.lobSubtitleBreakPoint;
      hotelWizardConfig.siteIdsWithoutSoftPackages = this.options.siteIdsWithoutSoftPackages || [];
      hotelWizardConfig.desktopAutoOpenCalendar = Boolean(isDesktop && this.options.desktopAutoOpenCalendar);

      hotelWizardConfig.enablePackageRates = this.options.enablePackageRates ?? hotelWizardConfig.enablePackageRates;
      hotelWizardConfig.percentSave = this.options.percentSave ?? hotelWizardConfig.percentSave;
      hotelWizardConfig.packageRatesTermsUrl =
        this.options.packageRatesTermsUrl ?? hotelWizardConfig.packageRatesTermsUrl;
      hotelWizardConfig.showDestinationField =
        this.options.showDestinationField ?? hotelWizardConfig.showDestinationField;

      const currentSiteId = props.context?.site?.id.toString();

      if (
        hotelWizardConfig.siteIdsWithoutSoftPackages.length !== 0 &&
        hotelWizardConfig.siteIdsWithoutSoftPackages.includes(currentSiteId)
      ) {
        hotelWizardConfig.enableAddFlight = false;
        hotelWizardConfig.enableAddCar = false;
      } else {
        hotelWizardConfig.enableAddFlight = this.options.enableAddFlight;
        hotelWizardConfig.enableAddCar = this.options.enableAddCar;
      }
    });

    hotelWizardState.updateDateFromConfig();

    if (this.options.destinationFromContext) {
      hotelWizardState.updateDestinationFromContext(this.props.context);
    }
  }

  public componentDidMount() {
    const { hotelWizardState, globalWizardState } = this.props.wizardState;

    if (globalWizardState.shouldUpdateCookie) {
      hotelWizardState.updateStateFromCookie();
    }
  }

  public render() {
    const ViewComponent = getComponentFromView(this.options.flexComponentView);

    return <ViewComponent {...this.props} />;
  }
}

export default WizardHotelPWAv2;
